export const NO_SENSOR_ID = 'no_sensor';

export const NO_SENSOR_OPTION = { id: NO_SENSOR_ID, name: 'No sensor' };

export const isNoSensorId = (id: string | number | undefined | null): boolean =>
  String(id ?? '') === NO_SENSOR_ID;

/** Prepend the No sensor sentinel to Sensor filter options. */
export function prependNoSensorOption<
  T extends { id: string | number; name?: string },
>(list: T[]): T[] {
  const filtered = (list ?? []).filter((item) => !isNoSensorId(item.id));
  return [NO_SENSOR_OPTION as T, ...filtered];
}
